import './Sidebar.css'

/* ── Icônes animaux SVG ── */
const IconAll = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/>
    <rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>
  </svg>
)
const IconDog = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 11C3 11 2 12 2 13.5S3 16 4.5 16H6v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3h1c1.5 0 3-1 3-3V9l2-4h-3l-1 2c-.5-.1-1-.2-1.5-.2C9 6.8 6 8 5 10l-.5 1z"/>
    <circle cx="9" cy="10" r=".8" fill="currentColor"/>
  </svg>
)
const IconCat = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 5v4c0 4.4 3.1 7 7 7s7-2.6 7-7V5l-2.5 2.5A6.5 6.5 0 0 0 12 7a6.5 6.5 0 0 0-4.5.5L5 5z"/>
    <path d="M9 19v2M15 19v2"/>
    <circle cx="9.5" cy="11.5" r=".6" fill="currentColor"/><circle cx="14.5" cy="11.5" r=".6" fill="currentColor"/>
  </svg>
)
const IconBird = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.5 5.5C19 3 16 2.5 14 4c-1.2.9-2 2.5-2 4 0 1 .3 2 .8 2.7L6 17H4v2h4l1.5-1.5"/>
    <path d="M12.8 10.7L18 8l1.5 3-2.5.5"/><path d="M8 17l-2 4"/>
    <circle cx="17" cy="6" r="1" fill="currentColor"/>
  </svg>
)
const IconReptile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12c0-2 1.5-3.5 4-4 1.5-.3 3 .2 4 1"/><path d="M10 9c2-1.5 5-1 6.5 1S18 14 16 15.5"/>
    <path d="M16 15.5c-1 1-2 1.5-4 1.5s-3-.5-3-2 .5-3 1-4"/>
    <circle cx="8.5" cy="9.5" r=".8" fill="currentColor"/><path d="M2 12l-1 1M2 12l-1-1"/>
  </svg>
)
const IconRabbit = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7.5 3C7 4.5 7 6 8 7.5M16.5 3C17 4.5 17 6 16 7.5"/>
    <path d="M6 8c-1.5.5-3 2-3 4 0 1.5 1 2.5 2.5 3V18a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3c1.5-.5 2.5-1.5 2.5-3 0-2-1.5-3.5-3-4H6z"/>
    <circle cx="9.5" cy="13" r=".6" fill="currentColor"/><circle cx="14.5" cy="13" r=".6" fill="currentColor"/>
  </svg>
)
const IconRodent = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="14" rx="6" ry="5"/><path d="M7 10C6 7 7 4 9.5 3.5S14 5 13 8"/>
    <path d="M17 10c1-3 0-5-2-6"/>
    <circle cx="10" cy="13" r=".6" fill="currentColor"/><circle cx="14" cy="13" r=".6" fill="currentColor"/>
    <path d="M10 17c.5.5 1.2.8 2 .8s1.5-.3 2-.8"/>
  </svg>
)
const IconFish = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 12c0-3-2.5-5.5-5.5-5.5S9 9 9 12s2.5 5.5 5.5 5.5S20 15 20 12z"/>
    <path d="M9 12L4 7l1 5-1 5 5-5z"/><circle cx="17" cy="11" r=".8" fill="currentColor"/>
  </svg>
)
const IconHorse = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 21v-5l1.5-4L10 9l4 .5 3.5-4 1 3.5-1.5 2V21"/>
    <path d="M14.5 9.5c.5-2 2-3.5 2-5"/><circle cx="15.5" cy="6" r=".8" fill="currentColor"/>
    <path d="M10 21v-4M16.5 21v-4"/>
  </svg>
)

const CATEGORIES = [
  { name:'Chiens',   Icon:IconDog,    color:'#f59e0b' },
  { name:'Chats',    Icon:IconCat,    color:'#8b5cf6' },
  { name:'Oiseaux',  Icon:IconBird,   color:'#10b981' },
  { name:'Reptiles', Icon:IconReptile,color:'#22c55e' },
  { name:'Lapins',   Icon:IconRabbit, color:'#ec4899' },
  { name:'Rongeurs', Icon:IconRodent, color:'#f97316' },
  { name:'Poissons', Icon:IconFish,   color:'#0ea5e9' },
  { name:'Chevaux',  Icon:IconHorse,  color:'#a16207' },
]

const REGIONS = [
  'Toute la France','Île-de-France','Auvergne-Rhône-Alpes','Bretagne',
  'Nouvelle-Aquitaine','Occitanie','PACA','Hauts-de-France','Grand Est',
  'Normandie','Pays de la Loire','Centre-Val de Loire','Bourgogne-Franche-Comté'
]

const OPT_ICONS = [
  {
    label: 'Vacciné',
    color: '#10b981',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 2l4 4-2 2-1-1-7 7 1 1-2 2-1-1-2 2-3-3 2-2-1-1 2-2 1 1 7-7-1-1 2-2z"/>
      </svg>
    ),
    key: 'vacc',
  },
  {
    label: 'Pucé',
    color: '#ec4899',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="7" strokeDasharray="2.5 2"/>
      </svg>
    ),
    key: 'micro',
  },
  {
    label: 'Pédigrée',
    color: '#3b82f6',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4"/><path d="M10 14l2 2 4-4"/>
      </svg>
    ),
    key: 'pedi',
  },
  {
    label: 'Éleveur Pro',
    color: '#f59e0b',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 21h8M12 17v4"/><path d="M5 3h14v8a7 7 0 0 1-14 0V3z"/>
        <path d="M5 7H2v3a3 3 0 0 0 3 3M19 7h3v3a3 3 0 0 1-3 3"/>
      </svg>
    ),
    key: 'pro',
  },
  {
    label: 'Particulier',
    color: '#8b5cf6',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
      </svg>
    ),
    key: 'part',
  },
  {
    label: 'Don',
    color: '#10b981',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 21s-7-4.35-9.5-8.5C.5 8.5 2.5 5 6 5c2 0 3.5 1.2 4 2.3.5-1.1 2-2.3 4-2.3 3.5 0 5.5 3.5 3.5 7.5C19 16.65 12 21 12 21z"/>
      </svg>
    ),
    key: 'don',
  },
]

export default function Sidebar({
  activeCat        = 'Tous',
  catCounts        = {},
  totalListings    = 0,
  region           = 'Toute la France',
  maxPrice         = '',
  filterVacc       = false,
  filterMicro      = false,
  filterPedi       = false,
  filterPro        = false,
  filterPart       = false,
  filterDon        = false,
  onCatChange      = () => {},
  onRegionChange   = () => {},
  onMaxPriceChange = () => {},
  onVaccChange     = () => {},
  onMicroChange    = () => {},
  onPediChange     = () => {},
  onProChange      = () => {},
  onPartChange     = () => {},
  onDonChange      = () => {},
}) {
  const filterValues   = { vacc: filterVacc, micro: filterMicro, pedi: filterPedi, pro: filterPro, part: filterPart, don: filterDon }
  const filterHandlers = { vacc: onVaccChange, micro: onMicroChange, pedi: onPediChange, pro: onProChange, part: onPartChange, don: onDonChange }

  return (
    <aside className="sidebar">

      {/* Espèce */}
      <div className="sb-card">
        <div className="sb-head">Espèce</div>
        <div
          className={`sb-row${activeCat === 'Tous' ? ' on' : ''}`}
          onClick={() => onCatChange('Tous')}
        >
          <span className="sb-row-icon" style={{ color: activeCat === 'Tous' ? 'var(--gold-dk)' : '#6366f1' }}>
            <IconAll />
          </span>
          Toutes espèces
          <span className="sb-cnt">{totalListings}</span>
        </div>
        {CATEGORIES.map(({ name, Icon, color }) => (
          <div
            key={name}
            className={`sb-row${activeCat === name ? ' on' : ''}`}
            onClick={() => onCatChange(name)}
          >
            <span className="sb-row-icon" style={{ color: activeCat === name ? 'var(--gold-dk)' : color }}>
              <Icon />
            </span>
            {name}
            <span className="sb-cnt">{catCounts[name] || 0}</span>
          </div>
        ))}
      </div>

      {/* Région */}
      <div className="sb-card">
        <div className="sb-head">Région</div>
        <select className="sb-sel" value={region} onChange={(e) => onRegionChange(e.target.value)}>
          {REGIONS.map(r => <option key={r}>{r}</option>)}
        </select>
      </div>

      {/* Prix max */}
      <div className="sb-card">
        <div className="sb-head">Prix maximum</div>
        <div className="sb-price-row">
          <input className="sb-price-input" placeholder="0 €" readOnly value="" style={{ opacity:0.4, width:44 }} />
          <span className="sb-price-sep">—</span>
          <input className="sb-price-input" type="number" placeholder="Max €" value={maxPrice} onChange={(e) => onMaxPriceChange(e.target.value)} />
        </div>
      </div>

      {/* Options */}
      <div className="sb-card">
        <div className="sb-head">Options</div>
        {OPT_ICONS.map(opt => (
          <div key={opt.key} className="sb-toggle-row">
            <span className="sb-toggle-label">
              <span className="sb-opt-icon" style={{ color: opt.color }}>{opt.icon}</span>
              {opt.label}
            </span>
            <label className="sb-toggle">
              <input type="checkbox" checked={filterValues[opt.key]} onChange={e => filterHandlers[opt.key](e.target.checked)} />
              <span className="sb-toggle-slider" />
            </label>
          </div>
        ))}
      </div>

    </aside>
  )
}